import { render, staticRenderFns } from "./InvestorRiskAcknowledgment.vue?vue&type=template&id=77cdb418&"
import script from "./InvestorRiskAcknowledgment.vue?vue&type=script&lang=js&"
export * from "./InvestorRiskAcknowledgment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports